import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SelectDropdown from './SelectDropdown';
import Utility from '../../../util/utilityfunctions';

const GroupSelect = (props) => {
	const {
		menuIsOpen,
		className,
		noOptionsMessage,
		defaultValue,
		isMulti,
		optionsList,
		isClearable,
		formLabel,
		id,
		isDisabled,
		value,
		closeMenuOnSelect,
		onChange,
		onBlur,
		onFocus,
		clearAllValuesLabel,
		customClearIcon,
		errorMessage,
		showErrorMessage,
		hideSelectedOptions
	} = props;

	const formatOptionLabel = (props, items) => {
		let isSelected = '';
		if (items) {
			if (Array.isArray(items)) {
				if (items?.some((x) => x.id === props?.id)) {
					isSelected = 'option-label-selected';
				}
			} else {
				if (items?.id === props?.id) {
					isSelected = 'option-label-selected';
				}
			}
		}

		return (
			<span className={`option-label ${isSelected} ${Utility.getMotifTheme()}`} title={props.label}>
				{props.label}
			</span>
		);
	};

	const formatGroupLabel = (props) => {
		return (
			<span className="group-label" title={props.label}>
				{props.label}
			</span>
		);
	};

	return (
		<StyledGroupSelect
			groupHeading
			isSearchable
			hideSelectedOptions={hideSelectedOptions}
			className={className}
			menuIsOpen={menuIsOpen}
			noOptionsMessage={noOptionsMessage}
			defaultValue={defaultValue}
			isMulti={isMulti}
			options={optionsList}
			isClearable={isClearable}
			formLabel={formLabel}
			id={id}
			isDisabled={isDisabled}
			value={value ? value : null}
			closeMenuOnSelect={closeMenuOnSelect}
			clearAllValuesLabel={clearAllValuesLabel}
			customClearIcon={customClearIcon}
			errorMessage={errorMessage}
			showErrorMessage={showErrorMessage}
			formatOptionLabel={(option) => formatOptionLabel(option, value)}
			formatGroupLabel={formatGroupLabel}
			onChange={onChange}
			onBlur={onBlur}
			onFocus={onFocus}
		/>
	);
};

GroupSelect.defaultProps = {
	noOptionsMessage: () => 'No results found.'
};

GroupSelect.propTypes = {
	noOptionsMessage: PropTypes.func,
	defaultValue: PropTypes.shape({
		label: PropTypes.string,
		options: PropTypes.shape({
			id: PropTypes.number,
			label: PropTypes.string,
			value: PropTypes.number
		})
	}),
	formLabel: PropTypes.string,
	onChange: PropTypes.func,
	clearAllValuesLabel: PropTypes.string,
	customClearIcon: PropTypes.bool
};

export default GroupSelect;

const StyledGroupSelect = styled(SelectDropdown)`
	width: 100%;
	font-size: 1.4rem;
	color: ${(props) => props.theme.color[`grey400`]};
	line-height: 2.4rem;
	label {
		font-size: 1.4rem;
		left: 0.7rem;
		top: 2.2rem;
		color: ${(props) => props.theme.color[`black`]} !important;
	}
	.react-select-container {
		.react-select__control {
			height: auto;
			background: ${(props) => props.theme.color[`grey100grey450`]} !important;
			&.react-select__control--menu-is-open .react-select__value-container--is-multi,
			&.react-select__control--is-focused .react-select__value-container--is-multi,
			&.react-select__value-container--is-multi {
				padding-top: 1.8rem;
			}
			.react-select__value-container {
				display: flex !important;
   				align-items: center !important;
				background: none;
				overflow-y: ${(props) => (props.isMulti ? 'auto' : 'none')};
				padding-top: ${(props) => (props.isMulti ? '0 !important' : '1.7rem')};
				position: relative;
				max-height: 4.8rem;
				margin-top: ${(props) => (props.isMulti ? '2rem !important' : 'none')};
				padding: ${(props) => (props.isMulti ? '' : '0 0.5rem !important')};
				&::-webkit-scrollbar {
					width: 0.6rem;
				}
				&::-webkit-scrollbar-track {
					background: ${(props) => props.theme.color[`grey235`]};
					width: 0.6rem;
				}
				&::-webkit-scrollbar-thumb {
					background: ${(props) => props.theme.color[`grey300`]};
					width: 0.6rem;
					cursor: pointer;
				}
				&::-webkit-scrollbar-thumb:hover {
					background: ${(props) => props.theme.color[`grey400`]};
				}
				&.react-select__value-container--is-multi {
					margin-top: 0;
					padding-top: 1.7rem;
					align-items: unset;
					input {
						color: ${(props) => props.theme.color[`black`]} !important;
					}
				}
				.react-select__value-container:not(.react-select__value-container--is-multi) {
					> div {
						.react-select__input {
							input {
								color: ${(props) => props.theme.color[`black`]} !important;
							}
						}
					}
				}
			}
			.react-select__indicators {
				.react-select__clear-indicator {
					margin: 0;
					padding: 0;
					svg {
						width: 2.2rem;
						height: 2.2rem;
					}
				}
			}
		}
	}
	.show {
		line-height: 2.4rem;
	}
	.react-select__single-value {
		color: ${(props) => props.theme.color[`black`]} !important;
	}
	.react-select__multi-value {
		color: ${(props) => props.theme.color[`white`]};
		display: flex;
		flex-direction: row-reverse;
		max-width: 10rem;
		background: ${(props) => props.theme.color[`grey500`]};
		margin: 0 0.5rem 0.5rem 0 !important;
		height: 2rem;

		.react-select__multi-value__label {
			font-size: 1.2rem;
			padding: 0 0.2rem !important;
			font-weight: normal;
			line-height: 1.9rem;
			color: ${(props) => props.theme.color[`white`]};
		}
		.react-select__multi-value__remove {
			height: 2.4rem;
			padding: 0 0.1rem !important;
			svg {
				max-width: none !important;
				fill: ${(props) => props.theme.color[`white`]};
			}
			&:hover {
				background-color: ${(props) => props.theme.color[`grey400`]};
			}
		}
	}
	.react-select__menu-list {
		background-color: ${(props) => props.theme.color[`grey200`]} !important;
		padding: 0 !important;
		overflow-y: auto;
		max-height: 25rem;
		min-height: 15.5rem;
		&::-webkit-scrollbar {
			width: 0.6rem;
		}
		&::-webkit-scrollbar-track {
			background: ${(props) => props.theme.color[`grey225`]};
			width: 0.6rem;
		}
		&::-webkit-scrollbar-thumb {
			background: ${(props) => props.theme.color[`grey300`]};
			width: 0.6rem;
			cursor: pointer;
		}
		&::-webkit-scrollbar-thumb:hover {
			background: ${(props) => props.theme.color[`grey400`]};
		}
		.react-select__menu-notice {
			padding: 0;
		}
		.react-select__menu-notice--no-options {
			padding: 2rem 0;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 10rem;
			color: ${(props) => props.theme.color[`black`]} !important;
		}
		.react-select__group {
			background-color: ${(props) => props.theme.color[`grey200`]} !important;
			.react-select__group-heading {
				background: ${(props) => props.theme.color[`grey200`]} !important;
				border-top: none !important;
				padding: 0.5rem 0 !important;
				border-bottom: 0.1rem solid ${(props) => props.theme.color[`grey300`]} !important;
				margin: 0.5rem 1rem;
				color: ${(props) => props.theme.color[`black`]} !important;
				.group-label {
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					display: block;
				}
			}
			.react-select__option--is-selected {
				background-color: ${(props) => props.theme.color[`grey200`]} !important;
			}
		}
		.react-select__option {
			padding: 0.8rem 1rem !important;
			background-color: ${(props) => props.theme.color[`white`]} !important;
			&:hover {
				background-color: ${(props) => props.theme.color[`grey200`]} !important;
			}
			.option-label {
				font-size: 1.2rem;
				height: 15px;
				color: ${(props) => props.theme.color[`black`]} !important;
				label {
					position: relative;
					top: initial;
				}
			}
			.option-label.option-label-selected.dark {
				color: ${(props) => props.theme.color[`yellow400`]} !important;
			}
		}
	}
	.react-select__dropdown-indicator {
		padding: 0.2rem;
	}
`;
